import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

const Pagination = ({ numToShow, attendanceLength, handleShowMore, handleShowAll }) => {
  const { t: tr } = useTranslation();
  if (numToShow >= attendanceLength) {
    return null;
  }

  return (
    <div className="pt-3 row d-flex justify-content-center mx-0">
      <div className="col-md-3 form-group">
        <button
          type="button"
          className="btn manage-button manage-red-button btn-block"
          onClick={handleShowMore}
        >{tr("manage:showMore_73")}</button>
      </div>

      <div className="col-md-3 form-group">
        <button
          type="button"
          className="btn manage-button btn-dark btn-block"
          onClick={handleShowAll}
        >{tr("manage:showAll_74")}</button>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  numToShow: PropTypes.number.isRequired,
  attendanceLength: PropTypes.number.isRequired,
  handleShowMore: PropTypes.func.isRequired,
  handleShowAll: PropTypes.func.isRequired,
};

export default Pagination;
